module.exports = __webpack_public_path__ + "img/tk-card-sns.b71e0ac8.png";